import React from 'react';
import Icon from '../../../components/AppIcon';
import AppointmentCard from './AppointmentCard';

const DailySchedule = ({ appointments, activeAppointment, onSelectAppointment, onStatusUpdate, onNavigate, onCall }) => {
  const today = new Date()?.toLocaleDateString('fr-FR', { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });

  const stats = {
    total: appointments?.length,
    completed: appointments?.filter(a => a?.status === 'completed')?.length,
    remaining: appointments?.filter(a => a?.status !== 'completed')?.length,
    urgent: appointments?.filter(a => a?.urgency === 'urgent')?.length
  };

  return (
    <div className="bg-card rounded-lg shadow-sm h-full flex flex-col">
      <div className="p-4 border-b border-border">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="text-xl font-semibold text-foreground">Planning du jour</h2>
            <p className="text-sm text-muted-foreground capitalize">{today}</p>
          </div>
          <button className="p-2 hover:bg-muted rounded-lg transition-colors">
            <Icon name="Calendar" size={20} className="text-muted-foreground" />
          </button>
        </div>

        <div className="grid grid-cols-4 gap-2">
          <div className="bg-primary/10 rounded-lg p-3">
            <p className="text-xs text-primary font-medium mb-1">Total</p>
            <p className="text-2xl font-bold text-primary">{stats?.total}</p>
          </div>
          <div className="bg-success/10 rounded-lg p-3">
            <p className="text-xs text-success font-medium mb-1">Terminés</p>
            <p className="text-2xl font-bold text-success">{stats?.completed}</p>
          </div>
          <div className="bg-warning/10 rounded-lg p-3">
            <p className="text-xs text-warning font-medium mb-1">Restants</p>
            <p className="text-2xl font-bold text-warning">{stats?.remaining}</p>
          </div>
          <div className="bg-error/10 rounded-lg p-3">
            <p className="text-xs text-error font-medium mb-1">Urgents</p>
            <p className="text-2xl font-bold text-error">{stats?.urgent}</p>
          </div>
        </div>
      </div>
      <div className="flex-1 overflow-y-auto p-4 scrollbar-thin">
        {appointments?.length > 0 ? (
          appointments?.map(appointment => (
            <div key={appointment?.id} onClick={() => onSelectAppointment(appointment)}>
              <AppointmentCard
                appointment={appointment}
                onStatusUpdate={onStatusUpdate}
                onNavigate={onNavigate}
                onCall={onCall}
                isActive={activeAppointment?.id === appointment?.id}
              />
            </div>
          ))
        ) : (
          <div className="flex flex-col items-center justify-center py-12">
            <Icon name="Calendar" size={48} className="text-muted-foreground mb-4" />
            <p className="text-muted-foreground text-center">
              Aucune intervention prévue aujourd'hui
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DailySchedule;